import { useEffect } from "react";

const useKeyboard = (callbacks) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          callbacks.onPrevious?.();
          break;
        case "ArrowRight":
          event.preventDefault();
          callbacks.onNext?.();
          break;
        case "Home":
          event.preventDefault();
          callbacks.onFirst?.();
          break;
        case "End":
          event.preventDefault();
          callbacks.onLast?.();
          break;
        case "Escape":
          event.preventDefault();
          callbacks.onEscape?.();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [callbacks]);
};

export default useKeyboard;
